import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog-actions',
  templateUrl: './confirm-dialog-actions.component.html',
  styleUrls: ['./confirm-dialog-actions.component.css']
})
export class ConfirmDialogActionsComponent implements OnInit {
  title: string;
  message: string;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogActionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogActionsModel) {
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogActionsModel {

  constructor(public title: string, public message: string) {
  }
}
